import React, { useMemo } from 'react'
import { Spin } from 'antd'
import Loading from './loading'
import './index.less'

export default function SpinLoading({
    className,
    wrapperClassName,
    spinning = true,
    size = 'default',
    children,
    indicator,
    style,
    noMargin = false,
    // 延迟展示：loading 在 delay 毫秒内就结束的话完全不展示（避免接口很快时闪一下），超过 delay 还在 loading 才展示。
    // 语义与 antd Spin 的 delay 完全一致（交给 antd 内部 debounce 实现，因此"隐藏"也会一起延迟）。
    // 需要恢复"立即展示/立即隐藏"时传 delay={0}。
    delay = 300,
    // 以下为兼容旧用法的参数，新版 loadingIcon（loading.jsx）已不再使用：
    // type 不再区分红/紫动图，tip 文案不再展示，fontSize 不再控制图标尺寸（尺寸统一跟随 size）
    // eslint-disable-next-line no-unused-vars
    type,
    // eslint-disable-next-line no-unused-vars
    tip,
    // eslint-disable-next-line no-unused-vars
    fontSize,
    ...rest
}) {

    const loadingIcon = useMemo(() => {
        let font_size = 60;
        switch (size) {
            case 'small':
                font_size = 12;
                break;
            case 'large':
                font_size = 24;
                break;
            default:
                font_size = 24;
                break;
        }

        if (indicator) {
            return indicator;
        }
        return (
            <Loading
                className='spin_loading_img'
                size={font_size}
                style={{
                    marginLeft: noMargin ? 0 : `-${font_size / 2}px`,
                    marginTop: noMargin ? 0 : `-${font_size / 2}px`,
                }}
            />
        );

    }, [indicator, size, noMargin]);

    return (
        <Spin
            spinning={spinning}
            // 由 antd Spin 自己处理 delay（debounce：展示和隐藏都延迟 delay 毫秒）
            delay={delay}
            wrapperClassName={wrapperClassName}
            className={className}
            size={size}
            indicator={loadingIcon}
            style={style}
            {...rest}
        >
            {children}
        </Spin>
    )

}
